import { render, staticRenderFns } from "./UserDetailClient.vue?vue&type=template&id=9b3686c0&scoped=true"
import script from "./UserDetailClient.vue?vue&type=script&lang=js"
export * from "./UserDetailClient.vue?vue&type=script&lang=js"
import style0 from "./UserDetailClient.vue?vue&type=style&index=0&id=9b3686c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3686c0",
  null
  
)

export default component.exports